<template>
    <div>
    <b-card no-body>
        <b-card-header>
            <span class="h5"> Aplicação de Recursos do Convênio </span>
        </b-card-header>
        <b-card-body>
            <app-tabela
                idTabela="tblAplicacoesRecursos"
                :itens="aplicacoesRecursos"
                :campos="campos"
                :itensPorPagina="itensPorPagina"
                :bordered="false"
                :small="false">
                <template slot="botoes">
                    <b-button-group class="float-right">
                        <btn-inserir-recurso
                            v-if="$temAcessoView('CONV-APL-01')"
                            :convenio="convenio"
                            @atualizarListaAplicacaoRecurso="atualizarListaAplicacaoRecurso()">
                        </btn-inserir-recurso>
                    </b-button-group>
                </template>
                <template slot="NuValorEconomicoSebrae" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.nuValorEconomicoSebrae | currency }}
                    </p>
                </template>
                <template slot="NuValorFinanceiroSebrae" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.nuValorFinanceiroSebrae | currency }}
                    </p>
                </template>
                <template slot="NuValorEconomicoParceiro" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.nuValorEconomicoParceiro | currency }}
                    </p>
                </template>
                <template slot="NuValorFinanceiroParceiro" slot-scope="data">
                    <p class="text-right m-0">
                        {{ data.nuValorFinanceiroParceiro | currency }}
                    </p>
                </template>
                <template slot="acoes" slot-scope="data">
                    <i>
                        <Btn-Atualizar-Recurso
                            v-if="$temAcessoView('CONV-APL-01')"
                            :convenio="convenio"
                            :aplicacaoRecurso="data"
                            @atualizarListaAplicacaoRecurso="atualizarListaAplicacaoRecurso()">
                        </Btn-Atualizar-Recurso>
                    </i>
                    <i>
                        <Btn-Excluir-Recurso
                            v-if="$temAcessoView('CONV-APL-01')"
                            :convenio="convenio"
                            :aplicacaoRecurso="data"
                            @atualizarListaAplicacaoRecurso="atualizarListaAplicacaoRecurso()">
                        </Btn-Excluir-Recurso>
                    </i>
                </template>
            </app-tabela>
        </b-card-body>
    </b-card>
        <div>
            <b-row>
                <b-col sm="12" md="12" lg="12" xl="12">
                    <b-card no-body>
                        <b-card-header>
                            <span class="h5"> Quadro de Resumo da Aplicação de Recursos </span>
                        </b-card-header>
                        <b-card-body>
                            <b-row>
                                <b-col sm="3" md="3" lg="3" xl="3">
                                    <span class="h6 text-info">PARTICIPAÇÃO</span>
                                </b-col>
                                <b-col sm="2" md="2" lg="2" xl="2">
                                    <span class="h6 text-info">ECONÔMICA</span>
                                </b-col>
                                <b-col sm="1" md="1" lg="1" xl="1">
                                    <span class="h6 text-info">%</span>
                                </b-col>
                                <b-col sm="2" md="2" lg="2" xl="2">
                                    <span class="h6 text-info">FINANCEIRA</span>
                                </b-col>
                                <b-col sm="1" md="1" lg="1" xl="1">
                                    <span class=" text-info">%</span>
                                </b-col>
                                <b-col sm="2" md="2" lg="2" xl="2">
                                    <span class="h6 text-info">TOTAL</span>
                                </b-col>
                                <b-col sm="1" md="1" lg="1" xl="1">
                                    <span class="h6 text-info">%</span>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col sm="3" md="3" lg="3" xl="3">
                                    <span class="h6">SEBRAE</span>
                                </b-col>
                                <b-col sm="2" md="2" lg="2" xl="2">
                                    <span class="h6">{{ convenioRecursos.partSebEconomica | currency }}</span>
                                </b-col>
                                <b-col sm="1" md="1" lg="1" xl="1">
                                    <span class="h6">{{ convenioRecursos.partSebEconomica > 0 ? parseFloat(convenioRecursos.partSebEconomica / (convenioRecursos.partSebEconomica + convenioRecursos.partParcEconomica) * 100, 2).toFixed(2) : 0 }}%</span>
                                </b-col>
                                <b-col sm="2" md="2" lg="2" xl="2">
                                    <span class="h6">{{ convenioRecursos.partSebFinanceira | currency }}</span>
                                </b-col>
                                <b-col sm="1" md="1" lg="1" xl="1">
                                    <span class="h6">{{ convenioRecursos.partSebFinanceira > 0 ? parseFloat(convenioRecursos.partSebFinanceira / (convenioRecursos.partSebFinanceira + convenioRecursos.partParcFinanceira) * 100, 2).toFixed(2) : 0 }}%</span>
                                </b-col>
                                <b-col sm="2" md="2" lg="2" xl="2">
                                    <span class="h6">{{ convenioRecursos.partSebTotal | currency }}</span>
                                </b-col>
                                <b-col sm="1" md="1" lg="1" xl="1">
                                    <span class="h6">{{ convenioRecursos.partSebTotal > 0 ? parseFloat(convenioRecursos.partSebTotal / (convenioRecursos.partSebTotal + convenioRecursos.partParcTotal) * 100, 2).toFixed(2) : 0 }}%</span>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col sm="3" md="3" lg="3" xl="3">
                                    <span class="h6">PARCEIRO</span>
                                </b-col>
                                <b-col sm="2" md="2" lg="2" xl="2">
                                    <span class="h6">{{ convenioRecursos.partParcEconomica | currency }}</span>
                                </b-col>
                                <b-col sm="1" md="1" lg="1" xl="1">
                                    <span class="h6">{{ convenioRecursos.partParcEconomica > 0 ? parseFloat(convenioRecursos.partParcEconomica / (convenioRecursos.partSebEconomica + convenioRecursos.partParcEconomica) * 100, 2).toFixed(2) : 0 }}%</span>
                                </b-col>
                                <b-col sm="2" md="2" lg="2" xl="2">
                                    <span class="h6">{{ convenioRecursos.partParcFinanceira | currency }}</span>
                                </b-col>
                                <b-col sm="1" md="1" lg="1" xl="1">
                                    <span class="h6">{{ convenioRecursos.partParcFinanceira > 0 ? parseFloat(convenioRecursos.partParcFinanceira / (convenioRecursos.partSebFinanceira + convenioRecursos.partParcFinanceira) * 100, 2).toFixed(2) : 0 }}%</span>
                                </b-col>
                                <b-col sm="2" md="2" lg="2" xl="2">
                                    <span class="h6">{{ convenioRecursos.partParcTotal | currency }}</span>
                                </b-col>
                                <b-col sm="1" md="1" lg="1" xl="1">
                                    <span class="h6">{{ convenioRecursos.partParcTotal > 0 ? parseFloat(convenioRecursos.partParcTotal / (convenioRecursos.partSebTotal + convenioRecursos.partParcTotal) * 100, 2).toFixed(2) : 0 }}%</span>
                                </b-col>
                            </b-row>

                            <b-row>
                                <b-col sm="3" md="3" lg="3" xl="3">
                                    <span class="h6 text-info">TOTAL</span>
                                </b-col>
                                <b-col sm="2" md="2" lg="2" xl="2">
                                    <span class="h6 text-info">{{ convenioRecursos.partSebEconomica + convenioRecursos.partParcEconomica | currency }}</span>
                                </b-col>
                                <b-col sm="1" md="1" lg="1" xl="1">
                                    <span class="h6 text-info"></span>
                                </b-col>
                                <b-col sm="2" md="2" lg="2" xl="2">
                                    <span class="h6 text-info">{{ convenioRecursos.partSebFinanceira + convenioRecursos.partParcFinanceira | currency }}</span>
                                </b-col>
                                <b-col sm="1" md="1" lg="1" xl="1">
                                    <span class=" text-info"></span>
                                </b-col>
                                <b-col sm="2" md="2" lg="2" xl="2">
                                    <span class="h6 text-info">{{ convenioRecursos.partSebTotal + convenioRecursos.partParcTotal | currency }}</span>
                                </b-col>
                                <b-col sm="1" md="1" lg="1" xl="1">
                                    <span class="h6 text-info"></span>
                                </b-col>
                            </b-row>
                        </b-card-body>
                        <b-card-footer>
                            <b-button-group class="float-right">
                                <btn-atualizar-recurso-rm
                                    v-if="$temAcessoView('CONV-APL-01')"
                                    :convenio="convenio">
                                </btn-atualizar-recurso-rm>
                            </b-button-group>
                        </b-card-footer>
                        
                    </b-card>
                </b-col>
            </b-row>
        </div>
        <div>
            <b-card no-body>
                <b-card-header>
                    <span class="h5"> Despesas Previstas x Despesas Realizadas </span>
                </b-card-header>
                <b-card-body>
                    <app-tabela
                        :itens="despesas"
                        :campos="camposDespesas"
                        :itensPorPagina="itensPorPagina"
                        :bordered="false"
                        :small="false">
                        <template slot="despesaPrevista" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.despesaPrevista | currency }}
                            </p>
                        </template>
                        <template slot="despesaRealizada" slot-scope="data">
                            <p class="text-right m-0">
                                {{ data.despesaRealizada | currency }}
                            </p>
                        </template>
                    </app-tabela>
                </b-card-body>
            </b-card>
        </div>
</div>
</template>

<script>

import BtnInserirRecurso from "../cadastro/AplicacaoRecursos/BtnInserirRecurso.vue"
import BtnAtualizarRecursoRm from "../cadastro/AplicacaoRecursos/BtnAtualizarRecursoRM.vue"
import BtnAtualizarRecurso from "../cadastro/AplicacaoRecursos/BtnAtualizarRecurso.vue"
import BtnExcluirRecurso from "../cadastro/AplicacaoRecursos/BtnExcluirRecurso.vue"
import ConveniosServicos from '../ConveniosServicos'

export default {
    components: {
        BtnInserirRecurso,
        BtnAtualizarRecursoRm,
        BtnAtualizarRecurso,
        BtnExcluirRecurso,
    },

    props: {
        convenio: {
            type: Object,
            default: () => ({})
        },
    },

    data() {
        return {
            erros: [],
            aplicacoesRecursos: [],
            convenioRecursos: [],
            despesas: [],
            campos: [
                {
                    key: 'idAplicacaoRecurso',
                    label: 'Id',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acao.descricao',
                    label: 'Ação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'natureza.vcDescricaoNatureza',
                    label: 'Natureza Despesa',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'NuValorFinanceiroSebrae',
                    label: 'Sebrae Financeiro',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'NuValorEconomicoSebrae',
                    label: 'Sebrae Econômico',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'NuValorFinanceiroParceiro',
                    label: 'Parceiro Financeiro',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'NuValorEconomicoParceiro',
                    label: 'Parceiro Econômico',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'acoes',
                    label: ''
                }
            ],
            camposDespesas:[
                {
                    key: 'acao',
                    label: 'Ação',
                    filterable: true,
                    sortable: true
                },
                {
                    key: 'despesaPrevista',
                    label: 'Despesa Prevista',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
                {
                    key: 'despesaRealizada',
                    label: 'Despesa Realizada',
                    filterable: true,
                    sortable: true,
                    tdClass: 'text-nowrap'
                },
            ],
            itensPorPagina: 5
        }
    },

    methods: {
        atualizarListaAplicacaoRecurso(){
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterPorId(this.convenio.idConvenio)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.aplicacoesRecursos = response.data.aplicacoesRecursos
                        this.convenioRecursos = response.data
                        this.$emit('atualizarDadosConvenio')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        obterDespesas(){
            this.$store.dispatch('addRequest')
            ConveniosServicos.obterDespesasPorConvenio(this.$route.params.convenioId)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.despesas = response.data
                        this.$emit('atualizarDadosConvenio')
                    }
                    else{
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        }
    },

    watch:{
        convenio(){
            if(this.convenio){
                this.aplicacoesRecursos = this.convenio.aplicacoesRecursos
                this.convenioRecursos = this.convenio
            }
        },
    },
    mounted(){
        this.obterDespesas()
    }
}
</script>
